/**
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
**/

/* HPX-515 start */

(function ($) {
  $(function () {
    var $main   = $('.variant-grouped-hpx-version');
    var $thumbs = $('.variant-thumbs-hpx-version');
    if (!$main.length || !$thumbs.length) return;

    if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('unslick');
    if ($main.hasClass('slick-initialized'))   $main.slick('unslick');

    $thumbs.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.variant-grouped-hpx-version',
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: false,
      focusOnSelect: true,
      mobileFirst: true,
      vertical: false,
      verticalSwiping: false,
      responsive: [
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
            arrows: true
            }
        }, 
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            arrows: true
          }
        }
      ]
    });

    $thumbs.on('click', '.slick-slide', function (e) {
      var hasAnchor = $(e.target).closest('a').length > 0;
      if (hasAnchor) e.preventDefault();
      var index = $(this).data('slick-index');
      if (typeof index === 'number') {
        $main.slick('slickGoTo', index, true);
      }
    });

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.variant-thumbs-hpx-version',
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: true,
      mobileFirst: true
    });

    $thumbs.slick('slickGoTo', 0, true);
    $main.slick('slickGoTo', 0, true);
    $thumbs.slick('setPosition');
    $main.slick('setPosition');

    var $sliderWrapper = $main.closest('.productView-nav.productView-main-slider');
    var total = $main.find('.slick-slide:not(.slick-cloned)').length;
    if ($sliderWrapper.length) {
      $sliderWrapper.attr('data-media-count', total);
    }
    $main.trigger('afterChange', [ $main, 0 ]);
  });
})(jQuery);

/* HPX-515 start */

/* HPX-35 start */

document.addEventListener('DOMContentLoaded', function () {
  function initSticky() {
    const el = document.querySelector('.sections-policies-block');
    if (!el) return; // element not found

    let originalTop = el.getBoundingClientRect().top + window.pageYOffset;
    let originalHeight = el.offsetHeight;
    let isFixed = false;

    function setFixed(on) {
      el.classList.toggle('is-fixed', on);
      isFixed = on;
    }

    function evaluate() {
      const y = window.pageYOffset;
      const naturalTop = originalTop;
      const naturalBottom = originalTop + originalHeight;

      if (y <= 0) {
        setFixed(false);
        return;
      }

      if (window.location.pathname === '/') {
        setFixed(y < naturalTop && y <= naturalBottom);
      } else {
        const viewportBottom = y + window.innerHeight;
        setFixed(viewportBottom <= naturalTop && y <= naturalBottom);
      }
    }

    function onResize() {
      const wasFixed = isFixed;
      setFixed(false);
      originalTop = el.getBoundingClientRect().top + window.pageYOffset;
      originalHeight = el.offsetHeight;
      setFixed(wasFixed);
      evaluate();
    }

    window.addEventListener('scroll', evaluate, { passive: true });
    window.addEventListener('resize', onResize);
    evaluate();
  }

  // Delay init until Shopify sections are ready
  setTimeout(initSticky, 500);
});


/* HPX-35 end */ 

/* HPX-348 */
  const maxDuration = 2 * 60 * 1000; // 2 minutes in milliseconds
  const intervalTime = 500; // check every 500ms
  let elapsedTime = 0;

  const checkFlyout = setInterval(() => {
    elapsedTime += intervalTime;

    const flyout = document.querySelector('[data-testid="FLYOUT"]');
    if (flyout) {      
      const firstInput = flyout.querySelector('input');
      const firstname = firstInput.id;
      const inputField = document.getElementById(firstname);      
      if (inputField) {
        inputField.focus(); 
        clearInterval(checkFlyout); // Stop checking once done
      }
    }
    // Stop checking after 2 minutes
    if (elapsedTime >= maxDuration) {
      clearInterval(checkFlyout);
    }
  }, intervalTime);
  
/* HPX-348 */

/* HPX-126 */
// custom script to manage MSRP LOGIC

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    // Toggle tooltip on .msrpText click
    if (e.target.classList.contains("msrpText")) {
      const tooltip = e.target.nextElementSibling;

      if (tooltip && tooltip.classList.contains("msrp-tooltip-container")) {
        // Hide all other tooltips first
        document.querySelectorAll(".msrp-tooltip-container").forEach(function (el) {
          if (el !== tooltip) el.style.display = "none";
        });

        // Toggle the clicked tooltip
        tooltip.style.display = tooltip.style.display === "block" ? "none" : "block";
      }
    }

    // Close tooltip on .msrp-tooltip-close click
    if (e.target.closest(".msrp-tooltip-close")) {
      const tooltip = e.target.closest(".msrp-tooltip-container");
      if (tooltip) tooltip.style.display = "none";
    }

    // Click outside to close all tooltips
    const isTooltip = e.target.closest(".msrp-tooltip-container");
    const isTrigger = e.target.classList.contains("msrpText");
    if (!isTooltip && !isTrigger) {
      document.querySelectorAll(".msrp-tooltip-container").forEach(function (tooltip) {
        tooltip.style.display = "none";
      });
    }
  });
});

/* HPX-126 */
/* HPX-260 */
const storelist = [
              {
                  storeCode: "CA",
                  storeName: "Canada",
                  storeUrl: "https://ca.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "EN",
                  supportedCurrencies: "CAD",
                  supportedStores: "CA"
              },             
              {
                  storeCode: "US",
                  storeName: "United States",
                  storeUrl: "https://hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "US"
              }, 
              {
                  storeCode: "AU",
                  storeName: "Australia",
                  storeUrl: "https://au.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "AUD",
                  supportedStores: "AU"
              }, 
              {
                  storeCode: "ROW",
                  storeName: "Global",
                  storeUrl: "https://row.hyperx.com/",
                  supportedLanguages: "EN, AR, DE, ES, ES419, FR, IT, ID, PL, pt-BR, RU, VI, TR, TH, KO, zh-CN, zh-TW, JA",
                  defaultLanguage: "EN",
                  supportedCurrencies: "USD",
                  supportedStores: "AF,AX,AL,DZ,AS,AD,AO,AI,AQ,AG,AR,AM,AW,AT,AZ,BS,BH,BD,BB,BE,BZ,BJ,BM,BT,BO,BQ,BA,BW,BR,IO,BN,BG,BF,BI,KH,CM,CV,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CK,CR,CI,HR,CW,CY,CZ,CD,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,GH,GI,GR,GL,GD,GP,GU,GT,GN,GW,GY,HT,VA,HN,HK,HU,IS,IN,ID,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KR,XK,KW,KG,LA,LV,LB,LS,LR,LI,LT,LU,MO,MK,MG,MW,MY,MV,ML,MT,MH,MQ,MR,MU,YT,MX,FM,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,NC,NZ,NI,NE,NG,NU,NF,MP,NO,OM,PK,PW,PS,PA,PG,PY,PE,PH,PN,PL,PT,PR,QA,RE,RO,RW,BL,SH,KN,LC,MF,PM,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,ZA,GS,SS,ES,LK,SD,SR,SJ,SZ,SE,CH,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TN,TR,TM,TC,TV,UG,UA,AE,UM,UY,UZ,VU,VN,VG,VI,WF,EH,ZM,ZW"
              }, 
              {
                  storeCode: "GB",
                  storeName: "United Kingdom",
                  storeUrl: "https://uk.hyperx.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN",
                  supportedCurrencies: "GBP",
                  supportedStores: "GB"
              }, 
              {
                  storeCode: "DE",
                  storeName: "Germany",
                  storeUrl: "https://de.hyperx.com/",
                  supportedLanguages: "DE, EN",
                  defaultLanguage: "DE",
                  supportedCurrencies: "EUR",
                  supportedStores: "DE"
              },
              {
                  storeCode: "FR",
                  storeName: "France",
                  storeUrl: "https://fr.hyperx.com/",
                  supportedLanguages: "EN, FR",
                  defaultLanguage: "FR",
                  supportedCurrencies: "EUR",
                  supportedStores: "FR"
              },
              {
                  storeCode: "Sandbox",
                  storeName: "Sandbox",
                  storeUrl: "https://hyperx-gg.myshopify.com/",
                  supportedLanguages: "EN",
                  defaultLanguage: "EN, DE, FR, IT, ID",
                  supportedCurrencies: "USD",
                  supportedStores: "Sandbox"
              }
          ];
var countryList = [
                {
                    'countrycode':'AR',
                    'countryname': 'Argentina'
                },
                {
                    'countrycode':'AU',
                    'countryname': 'Australia'
                },
                {
                    'countrycode':'BE',
                    'countryname': 'Belgium'
                },
                {
                    'countrycode':'BR',
                    'countryname': 'Brazil'
                },
                {
                    'countrycode':'BG',
                    'countryname': 'Bulgaria'
                },
                {
                    'countrycode':'CA',
                    'countryname': 'Canada'
                },
                
                {
                    'countrycode':'CL',
                    'countryname': 'Chile'
                },
                
                {
                    'countrycode':'CN',
                    'countryname': 'China'
                },
                
                {
                    'countrycode':'CO',
                    'countryname': 'Colombia'
                },
                
                {
                    'countrycode':'CR',
                    'countryname': 'Costa Rica'
                },
                
                {
                    'countrycode':'HR',
                    'countryname': 'Croatia'
                },
                
                {
                    'countrycode':'CZ',
                    'countryname': 'Czech Republic'
                },
                {
                    'countrycode':'DK',
                    'countryname': 'Denmark'
                },
                {
                    'countrycode':'EG',
                    'countryname': 'Egypt'
                },
                {
                    'countrycode':'EE',
                    'countryname': 'Estonia'
                },
                {
                    'countrycode':'FI',
                    'countryname': 'Finland'
                },
                {
                    'countrycode':'FR',
                    'countryname': 'France'
                },
                {
                    'countrycode':'DE',
                    'countryname': 'Germany'
                },
                {
                    'countrycode':'GR',
                    'countryname': 'Greece'
                },
                {
                    'countrycode':'GT',
                    'countryname': 'Guatemala'
                },
                {
                    'countrycode':'HK',
                    'countryname': 'Hong Kong'
                },
                {
                    'countrycode':'HU',
                    'countryname': 'Hungary'
                },
                {
                    'countrycode':'IN',
                    'countryname': 'India'
                },
                {
                    'countrycode':'ID',
                    'countryname': 'Indonesia'
                },
                {
                    'countrycode':'IL',
                    'countryname': 'Israel'
                },
                {
                    'countrycode':'IT',
                    'countryname': 'Italy'
                },
                {
                    'countrycode':'JP',
                    'countryname': 'Japan'
                },
                {
                    'countrycode':'JO',
                    'countryname': 'Jordan'
                },
                {
                    'countrycode':'KZ',
                    'countryname': 'Kazakhstan'
                },
                {
                    'countrycode':'KW',
                    'countryname': 'Kuwait'
                },
                {
                    'countrycode':'LV',
                    'countryname': 'Latvia'
                },
                {
                    'countrycode':'LT',
                    'countryname': 'Lithuania'
                },
                {
                    'countrycode':'MY',
                    'countryname': 'Malaysia'
                },
                {
                    'countrycode':'MX',
                    'countryname': 'Mexico'
                },
                {
                    'countrycode':'NL',
                    'countryname': 'Netherlands'
                },
                {
                    'countrycode':'NZ',
                    'countryname': 'New Zealand'
                },
                {
                    'countrycode':'NO',
                    'countryname': 'Norway'
                },
                {
                    'countrycode':'PE',
                    'countryname': 'Peru'
                },
                {
                    'countrycode':'PH',
                    'countryname': 'Philippines'
                },
                {
                    'countrycode':'PL',
                    'countryname': 'Poland'
                },
                {
                    'countrycode':'PT',
                    'countryname': 'Portugal'
                },
                {
                    'countrycode':'QA',
                    'countryname': 'Qatar'
                },
                {
                    'countrycode':'RO',
                    'countryname': 'Romania'
                },
                {
                    'countrycode':'SA',
                    'countryname': 'Saudi Arabia'
                },
                {
                    'countrycode':'RS',
                    'countryname': 'Serbia'
                },
                {
                    'countrycode':'SG',
                    'countryname': 'Singapore'
                },
                {
                    'countrycode':'SI',
                    'countryname': 'Slovenia'
                },
                {
                    'countrycode':'KR',
                    'countryname': 'South Korea'
                },
                {
                    'countrycode':'ES',
                    'countryname': 'Spain'
                },
                {
                    'countrycode':'SE',
                    'countryname': 'Sweden'
                },
                {
                    'countrycode':'CH',
                    'countryname': 'Switzerland'
                },
                {
                    'countrycode':'TW',
                    'countryname': 'Taiwan Region'
                },
                {
                    'countrycode':'TH',
                    'countryname': 'Thailand'
                },
                {
                    'countrycode':'TR',
                    'countryname': 'Turkey'
                },
                {
                    'countrycode':'UA',
                    'countryname': 'Ukraine'
                },
                {
                    'countrycode':'AE',
                    'countryname': 'United Arab Emirates'
                },
                {
                    'countrycode':'GB',
                    'countryname': 'United Kingdom'
                },
                {
                    'countrycode':'US',
                    'countryname': 'United States'
                },
                {
                    'countrycode':'UY',
                    'countryname': 'Uruguay'
                },
                {
                    'countrycode':'VN',
                    'countryname': 'Vietnam'
                },
  
             ];              

var languageList = [
                {
                    'langcode':'EN',
                    'langname': 'English'
                },
                {
                    'langcode':'AR',
                    'langname': 'Arabic'
                },
                {
                    'langcode':'DE',
                    'langname': 'Deutsch'
                },
                {
                    'langcode':'ES',
                    'langname': 'Español'
                },
                // {
                //     'langcode':'ES419',
                //     'langname': 'Español (LATAM)'
                // },
                {
                    'langcode':'FR',
                    'langname': 'Français'
                },
                {
                    'langcode':'IT',
                    'langname': 'Italiano'
                },
                {
                    'langcode':'ID',
                    'langname': 'Bahasa Indonesia'
                },
                {
                    'langcode':'PL',
                    'langname': 'Polski'
                },
                {
                    'langcode':'pt-BR',
                    'langname': 'Português (Brasil)'
                },
                {
                    'langcode':'RU',
                    'langname': 'Pyccкий'
                },
                {
                    'langcode':'VI',
                    'langname': 'Tiếng Việt'
                },
                {
                    'langcode':'TR',
                    'langname': 'Türkçe'
                },
                {
                    'langcode':'TH',
                    'langname': 'ไทย'
                },
                {
                    'langcode':'KO',
                    'langname': '한국어'
                },
                {
                    'langcode':'zh-CN',
                    'langname': '中文(简体)'
                },
                {
                    'langcode':'zh-TW',
                    'langname': '中文(繁體)'
                },
                {
                    'langcode':'JA',
                    'langname': '日本語'
                },
  
            ];                      


          /**
           * Handles the change event when a user selects a different country from the dropdown.
           *
           * @param {HTMLSelectElement} selectElement - The country <select> element that triggered the change.
           */
          function handleCountryChange(selectElement) {
            // Get the selected country code from the dropdown
            const selectedCountry = selectElement.value;             
            if(selectedCountry == 'global') {
              setCustomerLocation('');
            }                                   
            setcustomCountryURL(selectedCountry);            
          }

          function getstoreurl(storeCode) {
            const store = storelist.find(item => item.storeCode === storeCode);
            return store ? store.storeUrl : '';
          }              

          /**
           * Retrieves the store URL for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The corresponding store URL (e.g., "https://ca.hyperx.com/").
           */
          function getsupportedstoreurl(storecode) {
              // If storecode is blank or falsy, return empty string immediately
              if (!storecode || storecode.trim() === "") {
                return "";
              }

              // Find the store object that matches the given store code
              const store = storelist.find(item => item.storeCode === storecode);

              // Return the storeUrl if found, otherwise return empty string
              return store ? store.storeUrl : "";
            }


          
          /**
           * Finds the storeCode that supports a given country code.
           *
           * @param {string} fetchcountrycode - The country code to look for (e.g., "CA", "US").
           * @returns {string} - The storeCode that supports the given country code.
           */
          function getsupportedStores(fetchcountrycode) {
            var i = 0;
            var supportedstorecode = ''; // Initialize the result variable

            // Loop through each store in the storelist
            while (i < storelist.length) {
              // Get the supportedStores string for the current store
              var supportedStores = storelist[i].supportedStores;

              // Split the string into an array of individual country codes
              var supportedStoressplit = supportedStores.split(",");

              // Loop through each supported country code
              for (var g in supportedStoressplit) {
                // Check if the current country code matches the one we're looking for
                if (fetchcountrycode == supportedStoressplit[g]) {
                  // If matched, assign the storeCode of the current store
                  supportedstorecode = storelist[i]['storeCode'];
                }
              }

              // Move to the next store in the list
              i++;
            }

            // Return the matched storeCode (or empty string if not found)
            return supportedstorecode;
          }


          /**
           * Retrieves the supported languages for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - A comma-separated string of supported language codes (e.g., "EN, FR").
           */
         function getsupportedLanguages(storecode) {
            // Find the store object that matches the given store code
            const store = storelist.find(item => item.storeCode === storecode);

            // Return supportedLanguages if store exists, otherwise return empty string
            return store ? store.supportedLanguages : '';
          }


          /**
           * Retrieves the default language for a given store code.
           *
           * @param {string} storecode - The store code to look up (e.g., "CA", "US").
           * @returns {string} - The default language code for the specified store (e.g., "EN").
           */
          function getdefaultLanguage(storecode) {
              // If storecode is blank or falsy, return empty string immediately
              if (!storecode || storecode.trim() === "") {
                return "";
              }

              // Find the store object that matches the given store code
              const store = storelist.find(item => item.storeCode === storecode);

              // Return the defaultLanguage if found, otherwise return empty string
              return store ? store.defaultLanguage : "";
          }

          function getCountryCookie(name) {
              const value = `; ${document.cookie}`;
              const parts = value.split(`; ${name}=`);
              if (parts.length === 2) return parts.pop().split(';').shift();
          }

          function setcustomCountryURL(countryCode) {                          
              const storeCode = getsupportedStores(countryCode);
              const storeurl = getsupportedstoreurl(storeCode);
              const defaultlanguage = getdefaultLanguage(storeCode);

              const storeLang = document.documentElement.getAttribute("lang");
              const currentLanguageCode = storeLang.substring(0, 2).toLowerCase();

              const urlObj = new URL(window.location.href);

              // Build query params
              const params = new URLSearchParams(urlObj.search);
              params.delete("loc");

              // Only add loc if not global
              if (countryCode.toLowerCase() !== "global") {                
                params.append("loc", countryCode);
                setCustomerLocation(countryCode);
              }                          

              // Normalize base URL (remove trailing slash)
              const baseUrl = storeurl.endsWith("/") ? storeurl.slice(0, -1) : storeurl;

              // Get path without duplicate language codes
              let pathParts = urlObj.pathname.split("/").filter(Boolean);

              // Remove any existing language prefix
              if (pathParts[0] === currentLanguageCode) {
                pathParts.shift();
              }

              // Decide whether to inject language
              if (
                getsupportedLanguages(storeCode).includes(currentLanguageCode.toUpperCase()) &&
                currentLanguageCode.toUpperCase() !== defaultlanguage
              ) {
                pathParts.unshift(currentLanguageCode);
              }

              // Construct final URL
              let completeUrl = `${baseUrl}/${pathParts.join("/")}`;
              if (params.toString()) {
                completeUrl += `?${params.toString()}`;
              }

              window.location.href = completeUrl;
            }

        

        document.addEventListener("DOMContentLoaded", function () {

      function toPathLang(codeLower) {
        if (!codeLower) return "";
        if (codeLower === "zh-cn") return "zh-hans";
        if (codeLower === "zh-tw") return "zh-hant";
        if (codeLower === "pt-br") return "pt";
        return codeLower; // for en, fr, de, etc.
      }

      function isLangSegment(seg) {
        if (!seg) return false;
        const s = seg.toLowerCase();
        // Treat 2-letter codes & zh-hans/zh-hant as language segments
        return s.length === 2 || s === "zh-hans" || s === "zh-hant";
      }

      function initLanguageSelector() {
        const selectors = document.querySelectorAll('.language-selector');
        if (!selectors.length) return;

        selectors.forEach(function (selector) {
          selector.addEventListener('change', function () {
            const url = new URL(window.location.href);

            // 1) Read selected language
            const selectedLangRaw = this.value;                // e.g., "zh-TW" (keep for &lang=)
            const selectedLower   = selectedLangRaw.toLowerCase(); // "zh-tw"
            const selectedPathLang = toPathLang(selectedLower);     // "zh-hant"

            // 2) Country/store & default language
            let countrycode = (getCookie('customer_country') || '').trim();

            if (!countrycode) {
              countrycode = document.getElementById("RedirectCountry")?.value?.trim() || '';
            }
            const storecode = (countrycode && countrycode.toLowerCase() !== 'row')
              ? getstorecode(countrycode)
              : countrycode;

            const defaultLangLower = (getdefaultLanguage(storecode) || '').toLowerCase();
            const defaultPathLang  = toPathLang(defaultLangLower);

            // 3) Path handling — ensure no duplicates and correct first segment
            let segments = url.pathname.split('/').filter(Boolean);

            // Remove any language-like segments beyond index 0
            segments = segments.filter((seg, idx) => !(isLangSegment(seg) && idx !== 0));

            const firstIsLang = segments.length > 0 && isLangSegment(segments[0]);

            if (selectedPathLang === defaultPathLang) {
              // Selected equals default: remove any language segment from path
              if (firstIsLang) segments.shift();
            } else {
              // Selected differs from default: ensure exactly one language at the start
              if (firstIsLang) {
                segments[0] = selectedPathLang;
              } else {
                segments.unshift(selectedPathLang);
              }
            }

            // 4) Cookie (store normalized path lang)
            const currentstorecode = (typeof getCurrentStoreCodeDetails === 'function')
              ? (getCurrentStoreCodeDetails() || '')
              : '';
            setContinueCookie('continueStoreinfo', selectedPathLang + ',' + currentstorecode, 7);

            // 5) Build the new pathname (no forced trailing slash)
            url.pathname = '/' + segments.join('/');

            // 6) Query params: always set loc; lang only when selected==default, else delete it
            const params = url.searchParams;
            if (countrycode) params.set('loc', countrycode);

            if (selectedPathLang === defaultPathLang) {
              // Keep UI selection in the query param (original casing, e.g., "zh-TW")
              params.set('lang', selectedLangRaw);
            } else {
              params.delete('lang');
            }

            url.search = params.toString() ? '?' + params.toString() : '';

            // 7) Redirect
            window.location.href = url.toString();
          });
        });
      }

      initLanguageSelector();
});
        
        
      function getCurrentStoreCodeDetails() {
        var currentstorecode = getCookie('continueStoreinfo');   
        const cookieArray = currentstorecode.split(",");  
        let storecode     = cookieArray[1];
      
        return storecode;
      }

        
        function allcountrylist() {
            var currentstorecode = getCurrentStoreCodeDetails();            
              if(currentstorecode != null) {                  
                  var supportLanguage = getsupportedLanguages(currentstorecode);  
                  const supportedlanguage = supportLanguage.split(", ");      
                  const defaultlang = getCurrentlanguageCodeDetails();
                  buildDropDowns(supportedlanguage, defaultlang); // build new options of language                  
                var currentcountrycode = getsupportedStores(currentstorecode);         
              }  
                var options = "";
                options += "<option value='ROW'>Select Country/Region</option>";   
                var customer_country = getCountryCookie("customer_country")
                for (let j = 0; j<countryList.length; j++) {
                  var countrycode = countryList[j].countrycode;
                  var countryname = countryList[j].countryname;  

                  if (customer_country && countrycode &&  customer_country.toLowerCase() === countrycode.toLowerCase()) {          
                      options += "<option value='" + countrycode + "' selected>" + countryname + "</option>";       
                    } else {
                      options += "<option value='" + countrycode + "'>" + countryname + "</option>";       
                    }
                      
                }  
              $('#RedirectCountry').html(options);   
          }

          function getCurrentlanguageCodeDetails() {
            var currentstorecode = getCookie('continueStoreinfo');   
            const cookieArray = currentstorecode.split(",");
            let storelanguage = cookieArray[0].toUpperCase();          
            return storelanguage;          
          }

          function createOption(optioncode, label) {
            var option     = document.createElement("option");
            option.setAttribute("value", optioncode);
            option.innerHTML = label;  
            return option;
          }

          /* HPX-526 start */
          function buildDropDowns(supportLanguage, defaultlang) {
            var selections = document.getElementsByClassName('languagelist');  

            for (var i = 0; i < selections.length; i++) {
              // Clear existing options first
              selections[i].options.length = 0;

              // Add default "Select Language" option (not selected by default now)
              let defaultOption = createOption('', 'Select Language');
              selections[i].options.add(defaultOption);

              // Loop through supported languages
              for (var j = 0; j < supportLanguage.length; j++) {
                let langindex = languageList.findIndex(
                  (item) => item.langcode === supportLanguage[j]
                );

                if (langindex !== -1) {
                  let langvalue = languageList[langindex]['langname'];
                  let option = createOption(supportLanguage[j], langvalue);

                  // Auto-select the default language
                  if (supportLanguage[j].toUpperCase() === defaultlang.toUpperCase()) {
                    option.selected = true;
                  }

                  selections[i].options.add(option);
                }
              }
            }
          }


          
          function countrySelect() {
            const requestpath = window.location.pathname;
            var countrycode = document.getElementById("RedirectCountry").value;  
            var storecode = getstorecode(countrycode);  
            var supportLanguage = getsupportedLanguages(storecode);  
            var storeurl    = getstoreurl(storecode);
            var defaultlang = getdefaultLanguage(storecode);
            var redirectLink = storeurl + '?loc=' + countrycode + '&lang=' + defaultlang;  

            var selectedlang = document.getElementById("RedirectLanguage").value; 
            const supportedlanguage = supportLanguage.split(", ");  

            if (supportedlanguage.includes(selectedlang)) {
              if (defaultlang == selectedlang) {
                redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode + '&lang=' + selectedlang;
                redirectLink = redirectLink.replace('/' + selectedlang, '');       
              } else {                
                redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode;
              }
            } else {
              // Fallback: use default language if selected is not supported`              
                redirectLink = storeurl.replace(/\/$/, '') + requestpath + '?loc=' + countrycode + '&lang=' + defaultlang;              
            }
            // Remove PHP die; — not valid in JS
            // Instead, you can redirect or set form action:
            $("#RedirectSettings").attr("action", redirectLink);

            $("#RedirectLanguage").empty(); // remove old options    
            buildDropDowns(supportedlanguage, defaultlang); // build new options of language
            languageSelect();
          }
          /* HPX-526 END */          

        function footersettingsButton() {   
            allcountrylist();
            document.getElementById('choiceContainer').style.display = 'none';
            document.getElementById('settingsContainer').style.display = 'block';
            document.getElementById('back_btn').style.display = 'block';
          
        }

        function footerBackButton() {   
            document.getElementById('choiceContainer').style.display = 'block';
            document.getElementById('settingsContainer').style.display = 'none';
            document.getElementById('back_btn').style.display = 'none';
          
        }

/* HPX-260 */  

/* HPX-490 */  
function getcountrycode(fetchcountrycode) {    
    let countryindex     = countryList.findIndex((item) => item.countryname === fetchcountrycode);  
    if (countryindex !== -1) {
       currentcodecode = countryList[countryindex]['countrycode'];
    } else {      
      currentcodecode = 'notexist';
    }
    return currentcodecode;  
}
function getcontinuestoreurl(storecode) {
  const requestpath = window.location.pathname;
  let storeindex  = storelist.findIndex((item) => item.storeCode === storecode);
  let storeurl    = storelist[storeindex]['storeUrl'];
  let defaultlang = getdefaultLanguage(storecode);
  //var redirectLink = storeurl+'?loc='+countrycode +'&lang='+defaultlang;
  
  //var redirectLink = storeurl+'?lang='+defaultlang;

  const fullUrl = window.location.href;        
  const urlObj = new URL(fullUrl);    
  // Extract the pathname and search query
  const extractedUrl = urlObj.pathname + urlObj.search;    
  // Construct the base store URL
  const cleanedUrl = storeurl + (extractedUrl.startsWith("/") ? extractedUrl.substring(1) : extractedUrl);    
  // Remove existing `loc` parameter while preserving others
  const params = new URLSearchParams(urlObj.search);
  params.delete("loc");    
  // Append the new `loc` value
  params.append("loc", countryCode);    
  // Construct the final corrected URL
  const redirectLink = cleanedUrl.split("?")[0] + "?" + params.toString();
  
  return redirectLink;
}

function getstorename(storecode) {
  let storeindex     = storelist.findIndex((item) => item.storeCode === storecode);
  let storename    = storelist[storeindex]['storeName'];
  return storename;
}
        function getstorecode(fetchcountrycode) {           
            var i = 0;
            while (i < storelist.length) {
            var supportedStores = storelist[i].supportedStores;
            var supportedStoressplit = supportedStores.split(",");
            for (var g in supportedStoressplit){
              if( fetchcountrycode == supportedStoressplit[g] ){          
                currentstorecode = storelist[i]['storeCode'];
              }        
            }              
            i++;
          }
          return currentstorecode;
        }


        function languageSelect() {
            const requestpath = window.location.pathname;
            // Remove empty parts
            let segments = requestpath.split("/").filter(s => s !== "");

            const countrycode = document.getElementById("RedirectCountry").value;
            const storecode = (countrycode.toLowerCase() !== "row") ? getstorecode(countrycode) : countrycode;

            const storeurl = getstoreurl(storecode);

            // Keep the raw dropdown value for the query param (e.g., "zh-TW")
            const selectedLangRaw = document.getElementById("RedirectLanguage").value; // don't lowercase here
            const selectedLangLower = selectedLangRaw.toLowerCase();

            // Normalize to path-compatible languages
            const toPathLang = (codeLower) => {
              if (codeLower === "zh-cn") return "zh-hans";
              if (codeLower === "zh-tw") return "zh-hant";
              if (codeLower === "pt-br") return "pt";
              return codeLower; // for others, keep as-is (e.g., "en", "fr")
            };

            // Also normalize default language for correct equality comparison
            const defaultLangLower = getdefaultLanguage(storecode).toLowerCase();
            const defaultPathLang = toPathLang(defaultLangLower);
            const selectedPathLang = toPathLang(selectedLangLower);

            // Helper: is the segment a language segment? (2-letter or zh-hans/zh-hant)
            const isLangSegment = (seg) => {
              if (!seg) return false;
              const s = seg.toLowerCase();
              return s.length === 2 || s === "zh-hans" || s === "zh-hant";
            };

            // 1) Clean up any existing language segments: keep only one at the start if present
            // Remove language-like segments anywhere, then we'll add/replace at index 0 as needed.
            segments = segments.filter((seg, idx) => !(isLangSegment(seg) && idx !== 0));

            // 2) Now fix the first segment if it's a language
            const firstIsLang = segments.length > 0 && isLangSegment(segments[0]);

            if (selectedPathLang === defaultPathLang) {
              // Default == selected: remove any language in the path
              if (firstIsLang) segments.shift();
            } else {
              // Selected differs from default: ensure the path has exactly one language at the start
              if (firstIsLang) {
                segments[0] = selectedPathLang;
              } else {
                segments.unshift(selectedPathLang);
              }
            }

            // 3) Rebuild a clean path (no duplicate slashes)
            const cleanPath = segments.join("/");

            // Ensure single slash between base and path
            const base = storeurl.replace(/\/+$/, "/");
            const pathPart = cleanPath ? cleanPath.replace(/^\/+/, "") : "";

            // 4) Build query: always loc; lang only when default==selected (matches your current behavior)
            const locParam = "loc=" + encodeURIComponent(countrycode);
            // Use original dropdown value for &lang= (e.g., "zh-TW"), not the normalized path value
            const langParam = "lang=" + encodeURIComponent(selectedLangRaw);

            let redirectLink;
            if (selectedPathLang === defaultPathLang) {
              // No lang segment in path, keep &lang to preserve the UI selection
              redirectLink = base + pathPart + "?" + locParam + "&" + langParam;
            } else {
              // Path carries the language; omit &lang to avoid redundancy (and duplicates)
              redirectLink = base + pathPart + "?" + locParam;
            }

            $("#RedirectSettings").attr("action", redirectLink);
        }

        function getCookie(cname) {
              var name = cname + "=";
              var ca = document.cookie.split(';');
              for(var i=0; i<ca.length; i++) {
                  var c = ca[i];
                  while (c.charAt(0)==' ') c = c.substring(1);
                  if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
              }
              return "";
        }

        function setContinueCookie(cname, cvalue, exdays, options = {}) {
              // Hide popup (UI concern)
              const el = document.getElementById('popup');
              if (el) el.style.display = 'none';

              // Build attributes
              const expires = new Date(Date.now() + exdays * 24 * 60 * 60 * 1000).toUTCString();
              const path = options.path || '/';                      // <— define cookie Path here
              const domain = options.domain;                         // optional: ".your-root-domain.com"
              const sameSite = options.sameSite || 'Lax';            // Lax | Strict | None
              const secure = options.secure ?? (location.protocol === 'https:'); // default to true on HTTPS

              // Compose the Set-Cookie string
              const parts = [
                `${cname}=${cvalue}`,
                `Expires=${expires}`,
                `Path=${path}`,
                `SameSite=${sameSite}`
              ];
              if (domain) parts.push(`Domain=${domain}`);
              if (secure) parts.push('Secure');

              document.cookie = parts.join('; ');
        }

            function setCustomerLocation(currentlocation) {
                if(currentlocation.toLowerCase() == 'row'){
                    currentlocation = '';
                } 

              // Remove special characters, keep only letters, numbers, spaces, and dashes
              const sanitizedLocation = currentlocation.replace(/[^a-zA-Z0-9\s-]/g, '');

              const exdays = 7;
              const newdate = new Date();
              newdate.setTime(newdate.getTime() + (exdays * 24 * 60 * 60 * 1000));
              const expires = "expires=" + newdate.toUTCString();

              document.cookie = "customer_country=" + sanitizedLocation + "; path=/; " + expires;
            }


            window.addEventListener("pageshow", function(event) {
                const params = new URLSearchParams(window.location.search);
                const loc = params.get("loc");    
                const customer_country = getCookie('customer_country');        

                if (loc && customer_country !== loc) {
                    // Update cookie and dropdowns
                    setCustomerLocation(loc);

                    // const countrySelect = document.getElementById("country-selector-announcement-bar");
                    // const footercountry = document.getElementById("country-selector-Footer");

                    // if (countrySelect) countrySelect.value = loc;
                    // if (footercountry) footercountry.value = loc; // use new value, not old cookie
                }          
            });


    
        document.addEventListener("DOMContentLoaded", function () {

          const customer_country = getCookie('customer_country');
          const globeIcon = document.getElementById("icon__globe_country_announcement-bar");
          const globeMobileIcon = document.getElementById("icon__globe_country_Mobile");
          const globeFooterIcon = document.getElementById("icon__globe_country_Footer");
          
          const countrySelect = document.getElementById("country-selector-announcement-bar");
          const footercountry = document.getElementById("country-selector-Footer");
          const mobilecountry = document.getElementById("country-selector-Mobile");

          if (!customer_country) {
            if (globeIcon) globeIcon.style.display = "flex";
            if (globeMobileIcon) globeMobileIcon.style.display = "flex";
            if (globeFooterIcon) globeFooterIcon.style.display = "flex";
            countrySelect.value = 'global';
            footercountry.value = 'global';
            mobilecountry.value = 'global';
            return;
          }

          // Hide globe icon if country exists
          if (globeIcon) globeIcon.style.display = "none";
          if (globeMobileIcon) globeMobileIcon.style.display = "none";
          if (globeFooterIcon) globeFooterIcon.style.display = "none";

          const countryValue = customer_country.toUpperCase();

          if (countrySelect) countrySelect.value = countryValue;
          if (footercountry) footercountry.value = countryValue;
          if (mobilecountry) mobilecountry.value = countryValue;

        });



    document.addEventListener("DOMContentLoaded", function () {

        const params = new URLSearchParams(window.location.search);
        const loc = params.get("loc");

        if (!loc) return; // stop if no loc in URL
        const lloc = loc.toUpperCase(); // convert to uppercase
        if (lloc === 'ROW') {
            lloc = 'global';
        }
        const countrySelect = document.getElementById("country-selector-announcement-bar");
        const footercountry = document.getElementById("country-selector-Footer");
        const mobilecountry = document.getElementById("country-selector-Mobile");  
        if (mobilecountry) {
            mobilecountry.value = lloc;
        }
        
        if (countrySelect) {
          countrySelect.value = lloc;    
        }
        if (footercountry) {                                
          footercountry.value = lloc;              
        }          
    });




         
/* HPX-260 */  
